import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadAnalytics, trackPageView } from "./analytics";
import { readCampaignFromUrl, persistCampaign, getStoredCampaign } from "./campaign";
import { trackEvent } from "./analytics";

export function AnalyticsProvider({ children }) {
  const location = useLocation();
  useEffect(() => { loadAnalytics(); }, []);

  // Capture / persist UTMs + focus/intent on every navigation. Fire one
  // `campaign_landing` event the first time campaign params show up.
  // Also auto-scrolls to any [data-focus="…"] element matching ?focus=…
  useEffect(() => {
    const params = readCampaignFromUrl(location.search);
    const hasUtm = Object.keys(params.utm).length > 0;
    const hasFocus = !!params.focus || !!params.intent;

    if (hasUtm || hasFocus) {
      const existing = getStoredCampaign();
      const isFirstLand = !existing.landed_at;
      const merged = persistCampaign({ ...params, path: location.pathname });
      // Dedupe key — guard against React StrictMode double-invocation in dev
      // and any other unintended re-fires for the same URL.
      const landingKey = `${location.pathname}${location.search}`;
      if ((isFirstLand || hasUtm) && window.__usdd_last_landing !== landingKey) {
        window.__usdd_last_landing = landingKey;
        trackEvent("campaign_landing", {
          path: location.pathname,
          focus: merged.focus || null,
          intent: merged.intent || null,
          ...merged.utm,
        });
      }
    }

    // Auto-scroll to matching [data-focus] element (delay for DOM mount)
    if (params.focus) {
      const id = window.setTimeout(() => {
        const el = document.querySelector(`[data-focus="${params.focus}"]`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          el.classList.add("focus-highlight");
          window.setTimeout(() => el.classList.remove("focus-highlight"), 2400);
        }
      }, 500);
      return () => window.clearTimeout(id);
    }
  }, [location.pathname, location.search]);

  useEffect(() => { trackPageView(location.pathname + location.search); }, [location.pathname, location.search]);
  return children;
}
